var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{attrs:{"placeholder":"User email to make admin"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('b-btn',{on:{"click":_vm.makeAdmin}},[_vm._v("Make Admin")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }